import { httpClient } from "lib/axios";
import { isCounterAdmin } from "pages/Auth/permissionGuard";

export const stock_apis = {
  get_stock_list: async (counterId, pageNumber=1, pageSize=10) => {
    let url = `stock_list/?page_size=${pageSize}&page_number=${pageNumber}`;
    if (counterId) {
      url = `stock_list/?page_size=${pageSize}&page_number=${pageNumber}&counter=${counterId}`;
    }

    return await httpClient
      .get(url)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_stock_list_sent: async (counterId, pageNumber=1, pageSize=10) => {
    let url = `stock_list/?page_size=${pageSize}&page_number=${pageNumber}`;
    if (counterId) {
      url = `stock_list/?page_size=${pageSize}&page_number=${pageNumber}&from_counter=${counterId}`;
    }
    return await httpClient
      .get(url)
      .then(res => res.data)
      .catch(err => err);
  },
  get_stock_list_for_counter: async counterId => {
    let url = "counter_stock/";
    if (isCounterAdmin() || counterId) {
      url = `counter_stock/?counter_id=${counterId}`;
    } else {
      url = `counter_stock/`;
    }
    return await httpClient
      .get(url)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_stock_list_for_counter_view: async (counterId,pageNumber=1, pageSize=10) => {
    let url = "counter_stock/";
    if (isCounterAdmin() || counterId) {
      url = `counter_stock/?counter_id=${counterId}&view=true&page_size=${pageSize}&page_number=${pageNumber}`;
    } else {
      url = `counter_stock/?page_size=${pageSize}&page_number=${pageNumber}`;
    }
    return await httpClient
      .get(url)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_stock_products: async () => {
    return await httpClient
      .get(`stock_list/?product=true`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_stock_transfer_details: async stockId => {
    return await httpClient
      .get(`stock_list/?stock_id=${stockId}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  change_transfer_status: async payload => {
    return await httpClient.post(`stock_transfer/`, payload);
  },
  get_products: async (returnMaster=false) => {
    let url =`stock_list/?product=true`
    if(returnMaster){
      url += `&return_master=true`;
    }
    return await httpClient
      .get(url)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_products_paginated: async (search = "", pageNumber = 1, pageSize = 20, from_counter = null, return_master = false) => {
    let url = `stock_list/?product=${encodeURIComponent(search)}&page_size=${pageSize}&page_number=${pageNumber}`;
    if (from_counter) {
      url += `&from_counter=${from_counter}`;
    }
    if (return_master) {
      url += `&return_master=true`;
    }
    return await httpClient
      .get(url)
      .then(res => res.data)
      .catch(err => err);
  },
  transfer_stock: async payload => {
    return await httpClient.post(`stock_list/`, payload);
  },
  edit_stock_transfer: async payload => {
    return await httpClient.put(`stock_list/`, payload);
  },
  get_product_batches: async productId => {
    return await httpClient
      .get(`stock_list/?product_id=${productId}&return_master=true`)
      .then(res => {
        const product = res.data?.data || {};
        return { data: product.batch || [] };
      })
      .catch(err => err);
  },
};
